import { createLegacyModule } from "./createLegacyModule";

const keys = [
  "Add address",
  "Add remarks",
  "Add success",
  "address",
  "Agree",
  "Agree and read",
  "appDiscount",
  "Apple must pay more than 4",
  "Apple pay is not set, this payment method cannot be used!",
  "appTotal",
  "Back",
  "be usable",
  "Binding Mobile Phone Number",
  "Business address",
  "Business_has_orders",
  "Cancel",
  "cap_Confirm",
  "Captcha",
  "Cash on delivery",
  "Choose a language",
  "Choose a location",
  "Choose address",
  "Click for address",
  "Cold Chain Delivery",
  "complete",
  "Confirm",
  "Confirm logout?",
  "Confirm payment",
  "Confirm_the_order",
  "confirmed",
  "Contact merchant",
  "Contact number",
  "Contact person_",
  "Coupon saved in your wallet",
  "Coupon(s) available",
  "Data missing",
  "Default",
  "delete",
  "Delivery address",
  "Delivery_of",
  "Detailed address",
  "Details",
  "Discount",
  "Discounted price",
  "Distribution fee",
  "Enter a correct Phone Number",
  "Enter verification code",
  "exchange",
  "finished",
  "Food information",
  "Friday",
  "gsa Address",
  "I have read and accept the terms and conditions and the privacy policy.",
  "I have read and accept the TERMSANDCONDITIONS of BRANDNAME",
  "I have read and agreed",
  "immediately",
  "In-store pickup service agreement",
  "It is expected that the refund will be completed within 5-7 days",
  "It_has_been_served",
  "loading_in",
  "Loading...",
  "Login",
  "loginSuccess",
  "Logout",
  "Lunch box fee",
  "Make up the difference",
  "Max_Number",
  "Meal available",
  "Meal code",
  "Meal time",
  "Merchant has confirmed",
  "Modified success",
  "Monday",
  "more",
  "Mr",
  "Ms",
  "msgPushSuccess",
  "My coupon",
  "My_order",
  "Network connection is unstable, please try again!",
  "No coupons",
  "No more data",
  "Not in the scope of delivery",
  "Not logged in",
  "off",
  "ONE off",
  "Online payment",
  "Order Details",
  "Order is provided by",
  "Order_canceled",
  "Order_completed",
  "Order_successfully",
  "Over maximum order quantity",
  "Over ONE available",
  "package_price",
  "package_to",
  "Pay at the store",
  "Pay online",
  "Pay the remaining time",
  "Payment amount must be greater than 4",
  "Payment method",
  "Payment method 1",
  "Person",
  "phone",
  "Phone number",
  "phone number 2",
  "Pick_up",
  "Please choose the receiving address",
  "Please enter a detailed address",
  "Please enter address",
  "Please enter contact information",
  "Please enter reserved phone",
  "Please enter the correct contact information",
  "Please enter the name of the consignee",
  "Please enter the promo code to redeem",
  "Please enter the requirement of taste, preference and so on, and do not support the purchase of additional items on behalf of others.",
  "Please enter your name",
  "Please enter your phone",
  "Please_quit_and_try_again",
  "Popular restaurants",
  "Provide distribution",
  "Receive",
  "Refund completed",
  "Refund processing",
  "Refunding",
  "remark",
  "Reserved call",
  "Return to shopping cart",
  "Rules of use",
  "Saturday",
  "Self-collection time",
  "Send a single time",
  "Send verify code",
  "Served as soon as possible",
  "Service not available at the moment",
  "Service not available at the moment, please contact the merchant",
  "Set as default",
  "Share_the_qr_Code",
  "Shop closed",
  "Shop in Busy, delivery service not available in this moment",
  "Shop Order",
  "Shun Feng Cold Chain",
  "Sky Order",
  "Sold_3",
  "Submission of orders",
  "Submit orders",
  "submit_",
  "Submit_Order",
  "Successful operation",
  "Successful payment",
  "Successful redeem a coupon!",
  "Sunday",
  "Takeaway service is not open",
  "Takeaway_order",
  "Taken_meals",
  "Takeout",
  "Taste, preference, etc",
  "TERMSANDCONDITIONS",
  "The refund is expected to be completed within 1-3 working days",
  "The selected address is not within the scope of delivery",
  "Thursday",
  "to",
  "Total amount: ",
  "Tuesday",
  "unavailable",
  "Use mobile app scan Qr code, to pay by FPS.",
  "Verification code error",
  "Waiting for confirmation",
  "Waiting for meal",
  "Warm_prompt",
  "Wednesday",
  "Whether to continue?",
  "You still need to make up the difference of $ONE",
  "Your current address does not meet the delivery fee, please reselect"
];

export default createLegacyModule(keys);
